module.exports = __webpack_public_path__ + "static/media/ArrowUpSalesSlip.95538637.svg";